import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { getGapMonthsWithYear } from "../utils/GetGapMonthsWithYear";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [, setIndex] = useState(1);
  const toRotate = ["Web Developer", "Web Designer", "UI/UX Designer"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>
                    {`Hi! I'm Faris,`}{" "}
                    <span
                      className="txt-rotate"
                      dataPeriod="1000"
                      data-rotate='[ "Web Developer", "Android Developer", "UI/UX Designer" ]'
                    >
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>
                  <p>
                    Working at at{" "}
                    <a
                      href="https://sazankahenig.com"
                      // className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      PT. Sazanka Henig Solusi
                    </a>{" "}
                    has been a software engineer for{" "}
                    {getGapMonthsWithYear("2024-10", "now")}. Graduated from{" "}
                    <a
                      href="https://informatika.usk.ac.id"
                      // className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Syiah Kuala University
                    </a>{" "}
                    in 2024 with a GPA of 3.65 in Informatics majority
                    specializing in Software Engineering. Mastering UI/UX,
                    Full-Stack Development, Web Development, Android
                    Development, and Application Testing. Have a strong
                    curiosity and always want to learn new things. Motivated to
                    advance in a field of work that can provide room for me to
                    grow. Very comfortable working both in a team and
                    individually with change, challenges, multiple deadlines and
                    priorities.
                  </p>
                  <p>
                    I have experience in IT Developer specializing in web
                    development at{" "}
                    <a
                      href="https://sazankahenig.com"
                      // className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      PT. Sazanka Henig Solusi
                    </a>{" "}
                    with client{" "}
                    <a
                      href="https://www.toyota.astra.co.id/"
                      // className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      PT. Toyota Astra Motor
                    </a>
                    , UI/UX Design from MSIB at{" "}
                    <a
                      href="https://skilvul.com/"
                      // className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      PT. ImpactByte Teknologi Edukasi
                    </a>
                    , Web Development at Syiah Kuala University, Fullstack
                    development at Pacific Digital Printing Aceh, Android
                    Development from MSIB at{" "}
                    <a
                      href="https://grow.google/intl/id_id/bangkit/"
                      // className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Bangkit led by Google, GoTo, and Traveloka
                    </a>
                    , and Quality Assurance from my Bachelor's Final Project
                  </p>
                  <div className="d-flex align-items-center">
                    <svg
                      className="shadow"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="#0f0"
                      class="remixicon "
                    >
                      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"></path>
                    </svg>
                    <p className="ms-1 mb-0 p-0">
                      Working at PT. Sazanka Henig Solusi
                    </p>
                  </div>
                  <button onClick={() => (window.location.href = "#connect")}>
                    Let’s Connect <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                >
                  <img src={headerImg} alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
